export default "__VITE_ASSET__CNZPd1ep__"